import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ModalProps {
  deviceInfo: {
    thumbnail: any;
    description: any;
    title: string;
    productInfo: any;
    deviceType: string;
  };
}

interface PurchaseDialogContentProps {
  data: any;
  type: string;
  reset: () => void;
  isOpen: boolean;
  setModalContent: (data: any, isOpen: boolean, type: string) => void;
  setIsOpen: () => void;
}

// Create the Zustand store with persistence
export const usePurchaseDialogContent = create<PurchaseDialogContentProps>()(
  persist(
    (set, get) => ({
      type: '',
      isOpen: false,
      data: null,

      setIsOpen: () => {
        const value = get().isOpen;
        set({ isOpen: !value });
      },
      reset: () => {
        set({
          isOpen: false,
          data: null,
        });
      },

      setModalContent: (data: ModalProps | null, isOpen: boolean, type: string) => {
        set({
          data: data,
          isOpen,
          type,
        });
      },
    }),
    {
      name: 'purchase-dialog-bottom',
    }
  )
);
